/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import { Box, Stack } from '@mui/material';
import { motion } from 'framer-motion';

import EditorialButton from '../editorial/EditorialButton';

// Magazine-style event row used on the Events list page.
const EventDetailSection = ({ name, time, date, image, detail, eventId, index = 0 }) => {
  const flipped = index % 2 === 1;
  const handleClick = () => localStorage.setItem('eventId', eventId);

  return (
    <Box
      component="article"
      sx={{
        position: 'relative',
        py: { xs: 8, md: 12 },
        borderTop: '1px solid rgba(36,34,88,0.12)',
      }}
    >
      <Box sx={{ maxWidth: 1280, mx: 'auto', px: { xs: 3, md: 6 } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: { xs: 5, md: 9 },
            alignItems: 'center',
            direction: flipped ? 'rtl' : 'ltr',
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            style={{ direction: 'ltr' }}
          >
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: { xs: 280, md: 460 },
                overflow: 'hidden',
                background: 'var(--navy-700)',
              }}
            >
              <Box
                component="img"
                src={image}
                alt={name}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 800ms cubic-bezier(0.22,1,0.36,1)',
                  '&:hover': { transform: 'scale(1.04)' },
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  background:
                    'linear-gradient(180deg, transparent 0%, transparent 60%, rgba(7,6,26,0.55) 100%)',
                }}
              />
            </Box>
          </motion.div>

          <Box sx={{ direction: 'ltr' }}>
            <motion.div
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            >
              <Stack spacing={3}>
                <Box
                  sx={{
                    fontFamily: 'var(--font-mono)',
                    fontSize: 11,
                    letterSpacing: '0.22em',
                    textTransform: 'uppercase',
                    color: 'var(--teal-500)',
                  }}
                >
                  {date ? `${date}  ·  ${time}` : 'Upcoming Event'}
                </Box>
                <Box
                  sx={{
                    fontFamily: 'var(--font-display)',
                    fontWeight: 700,
                    fontSize: { xs: 32, md: 48 },
                    lineHeight: 1.02,
                    letterSpacing: '-0.018em',
                    color: 'var(--navy-500)',
                    maxWidth: 540,
                  }}
                >
                  {name}
                </Box>
                <Box
                  sx={{
                    fontFamily: 'var(--font-body)',
                    fontSize: 16.5,
                    lineHeight: 1.7,
                    color: 'var(--text)',
                    opacity: 0.85,
                    maxWidth: 540,
                  }}
                >
                  {detail}
                </Box>
                <Box>
                  <EditorialButton
                    variant="ghost"
                    onClick={handleClick}
                    href={`/event-detail/${eventId}`}
                  >
                    View Details
                  </EditorialButton>
                </Box>
              </Stack>
            </motion.div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EventDetailSection;
